// extracted by mini-css-extract-plugin
module.exports = {"root":"user-account_root__2qtT7","sidebar":"user-account_sidebar__-VznN","content":"user-account_content__SlAOC","tabs":"user-account_tabs__2foVg"};